import { FunctionComponent, useEffect } from 'react';
import { BodyText, Div } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { getLoggedInUser, phoneNumberVerified } from '../../store/actions';

const PhoneNumberVerified: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('phoneNumberVerification');

  useEffect(() => {
    return () => {
      dispatch(getLoggedInUser());
      dispatch(phoneNumberVerified());
    };
  }, [dispatch]);
  return (
    <Div>
      <BodyText>{t('PhoneNumberVerified.phoneNumberVerified')}</BodyText>
    </Div>
  );
};

export default PhoneNumberVerified;
